<template>
  <div class="dark">
    <Navbar />
    <div class="app-wrapper">
      <router-view :key="key" />
    </div>
  </div>
</template>
<script setup>
import Navbar from './components/Navbar.vue'
function key() {
  return this.$route.path
}
</script>
